import DataStudioReport from 'features/accounts/components/atoms/DataStudioReport/DataStudioReport';

export default DataStudioReport;
